import React from "react";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FormikLabel from "./FormLabel";

dayjs.extend(customParseFormat);

const DatePickerField = ({ field }) => {
  const { fieldId, fieldName, placeholder, required, attribute = {} } = field;
  const { views = ["year", "month", "day"], format = "DD/MM/YYYY", disablePast, disableFuture } = attribute;
  
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext();
  const isError = touched[fieldId] && errors[fieldId] && !values[fieldId];

  const selectedDate = values[fieldId] ? dayjs(values[fieldId], format) : null;

  const handleChange = (date) => {
    if (date) {
      setFieldValue(fieldId, date.format(format)); // Store formatted date
      setFieldTouched(fieldId, false); // Mark as touched
    }
  };
  


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth required={required} error={isError}>
        <FormikLabel text={fieldName} required={required} >
        </FormikLabel>
        <Field name={fieldId}>
          {() => (
            <DatePicker
              value={selectedDate}
              onChange={handleChange}
              views={views}
              format={format}
              disablePast={disablePast}
              disableFuture={disableFuture}
              slotProps={{
                textField: {
                  fullWidth: true, 
                  placeholder: placeholder || format,
                  size: "medium", 
                  autoComplete: "off",
                  error: false, 
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      borderWidth: "1px",
                      cursor: field.disabled ? "not-allowed" : "inherit",
                      borderColor: isError ? "red" : "gray", 
                    },
                    "& .MuiInputBase-input": {
                      padding: "8px",
                      borderRadius: "8px",
                      color: "black",
                      cursor: field.disabled || field.readOnly ? "not-allowed" : "inherit",
                      backgroundColor: field.disabled || field.readOnly ? "#f5f5f5" : "inherit",
                    }},
                },
              }}
            />
          )}
        </Field>
        {isError && (
          <FormHelperText style={{ color: "red" }}>
            {errors[fieldId]}
          </FormHelperText>
        )}
      </FormControl>
    </LocalizationProvider>
  );
};

export default DatePickerField;